import { isEqual } from "lodash";
import { ListOfItemsModel } from "../../../../mobxDataModels/listOfItemsModel";
import { StringModel } from "../../../../mobxDataModels/stringModel";
import { LoggingOpentelemetryMobx } from "../../../../mst/kinds/org";
import { ngParseLink } from "../../../../utils/linkParser/linkParser";
import { v4 as uuidv4 } from "uuid";

export function getLogsOpenTelemetryData(openTelemetry: LoggingOpentelemetryMobx) {
  function getDefaultOpenTelemetryEndpoint() {
    return openTelemetry.endpoint || "";
  }
  const opentelemetry_endpoint = StringModel.create({
    label: "Endpoint",
    initialValue: getDefaultOpenTelemetryEndpoint(),
    isRequired: true,
  });

  function getDefaultOpenTelemetryHeaders() {
    return Object.entries(openTelemetry.headers || {}).map(([headerKey, headerValue]) => ({
      id: uuidv4(),
      firstValue: headerKey,
      secondValue: headerValue,
    }));
  }
  const opentelemetry_headers = ListOfItemsModel.create({
    _items: getDefaultOpenTelemetryHeaders() as any,
  });

  function getDefaultOpenTelemetryCredentials() {
    return ngParseLink(openTelemetry.credentials || "", { kind: "secret" }).name;
  }

  const opentelemetry_credentials = StringModel.create({
    isRequired: true,
    label: "Credentials",
    initialValue: getDefaultOpenTelemetryCredentials(),
  });

  function isDirty() {
    let res = false;
    if (getDefaultOpenTelemetryEndpoint() !== opentelemetry_endpoint.value) {
      res = true;
    }
    if (
      !isEqual(
        getDefaultOpenTelemetryHeaders().map((h) => ({ key: h.firstValue, value: h.secondValue })),
        opentelemetry_headers.items.map((i) => ({ key: i.firstValue, value: i.secondValue })),
      )
    ) {
      res = true;
    }
    if (getDefaultOpenTelemetryCredentials() !== opentelemetry_credentials.value) {
      res = true;
    }
    return res;
  }

  function isValid() {
    let res = true;
    if (!opentelemetry_endpoint.isValid) res = false;
    if (!opentelemetry_credentials.isValid) res = false;
    return res;
  }

  function asObject() {
    const headers: Record<string, any> = {};
    for (const item of opentelemetry_headers.items) {
      if (item.firstValue) {
        headers[item.firstValue] = item.secondValue || "";
      }
    }

    const res: { opentelemetry: { endpoint: string; headers: Record<string, any>; credentials?: string } } = {
      opentelemetry: {
        endpoint: opentelemetry_endpoint.value,
        headers: headers,
      },
    };
    if (opentelemetry_credentials.value) {
      res.opentelemetry.credentials = ngParseLink(opentelemetry_credentials.value, { kind: "secret" }).absolute;
    }
    return res;
  }

  return {
    logProvider: "opentelemetry",
    endpoint: opentelemetry_endpoint,
    headers: opentelemetry_headers,
    credentials: opentelemetry_credentials,
    isDirty: isDirty,
    isValid: isValid,
    asObject: asObject,
  };
}
